import { useTranslation } from 'next-i18next';

import type { AccountTranslationKey } from '@/types/translation';

/**
 * account 네임스페이스 전용 t. account 는 i18next `CustomTypeOptions.resources` 타입에
 * 등록하지 않아(TS2589 회피, useCountryName 과 같은 이유) typed t() 대상이 아니다 —
 * raw i18n.t 를 account 키로 좁혀 캐스팅한다. 키 인자를 {@link AccountTranslationKey} 로
 * 좁혔으므로 raw string 캐스팅과 달리 시트에서 키가 사라지면 tsc 가 사용처를 잡는다.
 *
 * account 런타임 ns 는 각 페이지 serverSideTranslations 로 로드된다.
 */
export function useAccountT() {
  const { t } = useTranslation(['common']);
  // `account:` 접두사가 붙은 키는 default ns(common)와 무관하게 i18next 가 account
  // 번들에서 찾는다. i18n.t(global) 대신 훅의 t 를 쓰는 이유: 테스트가 useTranslation 을
  // `{ t }` 만 반환하도록 목킹(대부분 i18n 미제공)하는데, i18n.t 를 읽으면 그 목에서
  // undefined.t 로 터진다. t 는 항상 제공되므로 프로덕션·테스트 양쪽에서 안전하다.
  return t as (
    key: AccountTranslationKey,
    options?: Record<string, unknown>,
  ) => string;
}
